// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FallBackComponent {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2.5rem;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--Foreground);
}
.FallBackComponent .fallbackBody {
  flex: 1 1;
  display: flex;
  gap: 1.25rem;
  align-items: center;
  justify-content: space-between;
  max-width: 50%;
}
.FallBackComponent .fallbackBody div {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.FallBackComponent .fallbackBody div h1 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--TextColor);
}
.FallBackComponent .fallbackBody div h2 {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--TextColor);
}
.FallBackComponent .fallbackBody div p {
  font-size: 1rem;
  font-weight: 400;
  color: var(--TextColor);
}
.FallBackComponent .fallbackBody div p span {
  color: var(--AccentColor);
  cursor: pointer;
}
.FallBackComponent .fallbackBody div p span:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Components/ErrorBoundaryComponents/FallBackComponent.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCAAA;AACJ;AAAI;EACI,SAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAER;AADQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAGZ;AAFY;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AAIhB;AAFY;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;AAIhB;AAFY;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AAIhB;AAHgB;EACI,yBAAA;EACA,eAAA;AAKpB;AAJoB;EACI,0BAAA;AAMxB","sourcesContent":[".FallBackComponent{\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    padding: 2.5rem;\n    position: fixed;\n    top:0;\n    left:0;\n    background-color: var(--Foreground);\n    .fallbackBody{\n        flex: 1 1;\n        display: flex;\n        gap: 1.25rem;\n        align-items: center;\n        justify-content: space-between;\n        max-width: 50%;\n        div{\n            display: flex;\n            flex-direction: column;\n            gap: 1.25rem;\n            h1{\n                font-size: 2rem;\n                font-weight: 700;\n                color: var(--TextColor);\n            }\n            h2{\n                font-size: 1.25rem;\n                font-weight: 500;\n                color: var(--TextColor);\n            }\n            p{\n                font-size: 1rem;\n                font-weight: 400;\n                color: var(--TextColor);\n                span{\n                    color:var(--AccentColor);\n                    cursor: pointer;\n                    &:hover{\n                        text-decoration: underline;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
